/** @format */

import { useDispatch, useSelector } from 'react-redux';
import { VatReducersType } from './VatReducer';
import { useEffect, useMemo, useState } from 'react';
import { ItemLoaders } from '../../core/loaders/ItemLoaders';
import { FormGeneralHelper } from '../../helpers/FormGeneral';
import { VatCollectionInterface } from '../../interfaces/collections/VatCollectionInterface';
import { vatConstants } from './vatActions';
import { HeaderCheckBoxSelectListElement } from '../../views/lib/search/listTableHeader/HeaderCheckBoxSelectList';
import VatInterface from '../../interfaces/platform/VatInterface';

/** @format */
export function useVats(): {
    vats: VatCollectionInterface | undefined;
    vatsSelect: Array<HeaderCheckBoxSelectListElement> | undefined;
    triedLoading: boolean;
} {
    const dispatch = useDispatch();
    const [triedLoading, setTryingLoading] = useState<boolean>(false);
    const itemLoader: ItemLoaders = useMemo(() => {
        return new ItemLoaders(dispatch);
    }, [dispatch]);
    const { vats } = useSelector((state: { vatReducer: VatReducersType }) => {
        return state.vatReducer;
    });
    const [vatsSelect, setVatsSelect] = useState<Array<HeaderCheckBoxSelectListElement> | undefined>(undefined);

    useEffect(() => {
        if (!triedLoading && vats === undefined) {
            setTryingLoading(true);
            itemLoader.getListWithCallback(
                FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/vats')),
                'disregard',
                [],
                [
                    {
                        name: 'renderPriority',
                        value: 'ASC',
                    },
                ],
                (items: VatCollectionInterface): void => {
                    const vatList: Array<HeaderCheckBoxSelectListElement> = [];
                    const tmpMembers: Array<VatInterface> = [];
                    items['hydra:member'].forEach((vat) => {
                        const tmpVat: VatInterface = {
                            ...vat,
                            '@id': '/api/' + vat['@id'].split('/api/')[1],
                        };

                        vatList.push({
                            name: `${vat.description}`,
                            value: vat.id,
                        });

                        tmpMembers.push(tmpVat);
                    });
                    const tmpItems = {
                        ...items,
                        'hydra:member': tmpMembers,
                    } as VatCollectionInterface;
                    dispatch({
                        type: vatConstants.VAT_LIST,
                        vats: tmpItems,
                    });
                    setVatsSelect(vatList);
                },
                { propagateDataToCallback: true, dispatchAfterCallback: false }
            );
        }
    }, [vats, triedLoading, itemLoader, dispatch]);

    return useMemo(() => ({ vats, vatsSelect, triedLoading }), [vats, vatsSelect, triedLoading]);
}
